import { Box, Typography, Button, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ActivityContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '40px',
  padding: '20px',
  maxWidth: '1100px',
  alignItems: 'flex-start',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const ActivityColumnContainer = styled(ActivityContainer)`
  flex-direction: column;
`;

export const ActivityLeft = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

// Activity Pill with Pointed Corner
export const ActivityPill = styled(Box)`
  width: 55%;
  position: relative;
  display: block;
  background: #000000;
  color: white;
  padding: 12px 16px 12px 0;
  font-size: 18px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-radius: 0 20px 0 0;
  margin-bottom: 12px;
  margin-left: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-drag: none;
  pointer-events: auto;

  @media (max-width: 768px) {
    padding: 6px 12px 6px 10px;
    font-size: 11px;

    &::after {
      bottom: -6px;
      border-width: 6px 6px 0 0;
    }
  }
`;

export const FullActivityPill = styled(ActivityPill)`
  width: 100%;
  text-align: center;
`;

export const ActivityRight = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ActivityHeader = styled(Box)`
  text-align: center;
`;

export const ActivityTitle = styled(Typography)`
  font-size: 35px;
  color: #EE6D29;
  font-weight: 700;
  margin-bottom: 16px;
  text-align: left;
  margin-top: 0;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-drag: none;
  pointer-events: auto;
`;

export const ActivityPollTitle = styled(ActivityTitle)`
  text-align: center;
`;

export const ActivityContent = styled(Box)`
  text-align: left;
  font-size: 1rem;
  line-height: 1.6;
  color: #374151;
  white-space: pre-line;
`;

export const JournalingTextArea = styled(TextField)`
  width: 100%;
  background-color: var(--brand-surface, #fff) !important;

  & .MuiOutlinedInput-root {
    font-size: 16px;
    font-family: "Source Sans Pro", "Helvetica Neue", sans-serif;
    line-height: 1.5;
    padding: 16px;
    align-items: flex-start;

    & fieldset {
      border: 2px solid #FF7676;
      border-radius: 8px;
    }

    &:hover fieldset {
      border-color: #FF7676;
    }

    &.Mui-focused fieldset {
      border-color: #FF7676;
      box-shadow: 0 0 0 3px rgba(255, 118, 118, 0.15);
    }
  }

  & .MuiInputBase-input {
    color: var(--brand-text, #000);
    padding: 0;
  }

  & .MuiInputBase-input::placeholder {
    color: #a0aec0;
    opacity: 1;
  }
`;

export const PledgeLayout = styled(Box)`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
`;

export const LeftContent = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const RightBox = styled(Box)`
  flex: 1;
  margin: 20px;
  margin-top: 60px;
  background-color: #0097b2;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const IconWrapper = styled(Box)`
  margin-bottom: 16px;
  svg {
    font-size: 48px;
    color: #fff;
  }
`;

export const PledgeDescription = styled(Typography)`
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  margin-bottom: 24px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-drag: none;
  pointer-events: auto;
`;

export const SubmitButton = styled(Button)`
  align-self: center;
  padding: 12px 32px;
  background-color: #FF7676;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 16px;

  &:hover {
    background-color: #FF7676;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background-color: #DDDDDD;
    cursor: not-allowed;
    transform: none;
  }
`;

export const SaveButton = styled(SubmitButton)`
  background-color: #FF7676;

  &:hover {
    background-color: #FF7676;
  }

  &:disabled {
    background-color: #DDDDDD;
  }
`;

export const Text = styled(Box)`
  text-align: center;
  font-weight: 600;
  color: var(--brand-text, #000000);
  margin: 10px auto;
  font-size: 22px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-drag: none;
  pointer-events: auto;
`;

export const LinkInput = styled(TextField)`
  width: 60%;
  margin: 10px auto;
  background-color: var(--brand-surface, #fff) !important;

  @media (max-width: 768px) {
    width: 100%;
  }

  & .MuiOutlinedInput-root {
    font-size: 16px;
    font-family: "Source Sans Pro", "Helvetica Neue", sans-serif;

    & fieldset {
      border: 2px solid #0097B2;
      border-radius: 8px;
    }

    &:hover fieldset {
      border-color: #0097B2;
    }

    &.Mui-focused fieldset {
      border-color: #0097B2;
      box-shadow: 0 0 0 3px rgba(0, 151, 178, 0.15);
    }
  }

  & .MuiInputBase-input {
    color: var(--brand-text, #000);
    padding: 16px;
  }

  & .MuiInputBase-input::placeholder {
    color: #a0aec0;
    opacity: 1;
  }
`;

export const FileUploadButton = styled(Button)`
  padding: 10px 20px;
  background-color: #0097B2;
  border: none;
  border-radius: 6px;
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  display: block;
  margin: 10px auto;
  width: 60%;
  transition: all 0.2s ease;
  &:hover {
    background-color: #0097B2;
  }
`;

export const PollContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 700px;
`;

export const PollOption = styled(Box)`
  width: 100%;
  box-sizing: border-box;
  padding: 14px 20px;
  border: ${props => (props.selected ? '2px solid #0097B2' : '1px solid var(--brand-border, #E5E7EB)')};
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  gap: 16px;
  background-color: ${props => (props.selected ? 'rgba(0, 151, 178, 0.06)' : 'var(--brand-surface, #fff)')};

  &:hover {
    border-color: #0097B2;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
  }
`;

export const PollOptionBadge = styled(Box)`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 15px;
  border: ${props => (props.selected ? 'none' : '1.5px solid var(--brand-border, #D1D5DB)')};
  background-color: ${props => (props.selected ? '#0097B2' : 'transparent')};
  color: ${props => (props.selected ? '#fff' : 'var(--brand-text-muted, #6B7280)')};
`;

export const PollOptionText = styled(Typography)`
  flex: 1;
  text-align: left;
  font-size: 18px;
  font-weight: 500;
  color: var(--brand-text, #000);
`;

export const ActivityWrapper = styled(Box)`
  position: relative;
  width: 100%;
`;

export const DiscussionButton = styled(Button)`
  padding: 16px 40px;
  background-color: #0097B2;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 24px;
  margin-bottom: 16px;
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-transform: none;

  &:hover {
    background-color: #007A90;
    color: white;
  }

  i {
    font-size: 16px;
  }
`;
